<div class="rows has-gap-3">
    <div class="row">
        <div class="columns is-mobile is-marginless is-aligned-center">
            <div class="column">
                <!-- Cas classique -->
                @if (!ticketLine?.popover) {
                    <h3
                        [checkoutCy]="labelCheckoutCy"
                        class="text has-text-left is-marginless"
                        [ngClass]="{
                            'is-level-1 has-text-weight-bold': isTitle,
                            'is-level-2': !isTitle,
                        }"
                    >
                        {{ ticketLine?.label || label }}
                        @if (!isTitle && ticketLine?.qty > 1) {
                            <span class="has-text-weight-bold">(x{{ ticketLine.qty }})</span>
                        }
                    </h3>
                } @else if (ticketLine?.label && ticketLine?.popover) {
                    <!-- Dans les cas FMS et CLE 4G, on affiche un (i) avec popover explicatif -->
                    <div class="is-flex is-aligned-center">
                        <h3>
                            <span
                                class="text is-level-2 is-marginless"
                                [checkoutCy]="'ticket_label_' + ticketLine.gencode"
                            >
                                {{ ticketLine.label || label }}
                            </span>
                            <checkout-ticket-tooltip [popover]="ticketLine.popover" [dataTcCategory]="dataTcCategory" />
                        </h3>
                    </div>
                }
            </div>

            <div class="column is-narrow">
                @if (!isTitle && ticketLine?.price === 0) {
                    <span class="text is-level-2">Gratuit</span>
                }
                @if (!isTitle && ticketLine?.price !== 0 && ticketLine?.isIncludedPrice) {
                    <span class="text is-level-2">Inclus</span>
                }
                @if (!isTitle && ticketLine?.isInstantDiscount && showPrice) {
                    <span class="text is-level-3">-</span>
                }
                @if (showPrice) {
                    <trg-price
                        [checkoutCy]="priceCheckoutCy"
                        [inheritFontSize]="true"
                        [price]="price || 0"
                        [isInlined]="true"
                        [hasPeriod]="hasPeriod"
                        [isBold]="isTitle"
                        [size]="
                            'text mb-0' +
                            (isTitle ? ' has-text-weight-bold is-level-1' : ' has-text-weight-normal is-level-2')
                        "
                    />
                }
            </div>
        </div>
    </div>

    <!-- Si extra info -->
    @if (ticketLine?.extraInfo) {
        <div class="row">
            <span class="text is-block is-marginless is-level-3">{{ ticketLine.extraInfo }}</span>
        </div>
    }

    <!-- Si le prix mensuel évolue au bout d'un certain temps -->
    @if (!hasPromoHome && ticketLine?.periodText && ticketLine?.periodPrice) {
        <div class="row">
            <span class="text is-block is-level-3 is-marginless">
                {{ ticketLine.periodText }}
                <trg-price
                    [isInlined]="true"
                    [price]="ticketLine?.periodPrice"
                    [inheritFontSize]="true"
                    [hasPeriod]="true"
                />
            </span>
        </div>
    }
    <!-- Si subtitle -->
    @for (subtitle of subTitlesLabelOnly; track subtitle) {
        <div class="row">
            <span class="text is-block is-level-3">{{ subtitle.label }}</span>
        </div>
    }

    @if (subTitlesWithPrice.length > 0) {
        <div class="row">
            @for (subtitle of subTitlesWithPrice; track subtitle) {
                <div class="columns">
                    <div class="column">
                        <span
                            class="text is-block is-level-3 is-marginless is-flex is-spaced-between has-text-weight-semibold"
                        >
                            <span>{{ subtitle.label }}</span>
                            @if (subtitle.price) {
                                <trg-price
                                    [isInlined]="true"
                                    [inheritFontSize]="true"
                                    [price]="subtitle.price"
                                    [hasPeriod]="true"
                                />
                            }
                        </span>
                    </div>
                </div>
            }
        </div>
    }
</div>
